"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNavigation = PageNavigation;
exports.default = exports.PageLink = void 0;

var _react = _interopRequireDefault(require("react"));

require("@kuali/student-theme");

var _Pagination = require("@instructure/ui-pagination/lib/Pagination");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageLink = _Pagination.Pagination.Page;
exports.PageLink = PageLink;

function PageNavigation(_ref) {
  var as = _ref.as,
      children = _ref.children,
      compact = _ref.compact,
      current = _ref.current,
      disabled = _ref.disabled,
      label = _ref.label,
      labelNext = _ref.labelNext,
      labelPrev = _ref.labelPrev,
      numPages = _ref.numPages,
      onPageLinkClicked = _ref.onPageLinkClicked;
  var generatedPages = [];

  if (numPages) {
    var _loop = function _loop(i) {
      generatedPages.push( /*#__PURE__*/_react.default.createElement(PageLink, {
        current: current === i,
        key: i,
        onClick: function onClick() {
          onPageLinkClicked(i);
        }
      }, i));
    };

    for (var i = 1; i <= numPages; i++) {
      _loop(i);
    }
  }

  return (/*#__PURE__*/_react.default.createElement(_Pagination.Pagination, {
      as: as,
      disabled: disabled,
      label: label,
      labelNext: labelNext,
      labelPrev: labelPrev,
      margin: "small",
      variant: !compact ? 'full' : 'compact'
    }, numPages ? generatedPages : children)
  );
}

PageNavigation.displayName = 'PageNavigation';
PageNavigation.defaultProps = {
  as: 'nav',
  compact: true,
  disabled: false,
  labelNext: 'Next Page',
  labelPrev: 'Previous Page',
  pages: []
};
PageNavigation.propTypes = {
  as: _propTypes.default.string,
  compact: _propTypes.default.bool,
  current: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  labelNext: _propTypes.default.string,
  labelPrev: _propTypes.default.string,
  numPages: _propTypes.default.number,
  onPageLinkClicked: _propTypes.default.func,
  pages: _propTypes.default.arrayOf(_propTypes.default.element)
};
var _default = PageNavigation;
exports.default = _default;